/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CommentReactionNotificationActionData
 */
export interface CommentReactionNotificationActionData {
    /**
     * 
     * @type {string}
     * @memberof CommentReactionNotificationActionData
     */
    type: CommentReactionNotificationActionDataTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof CommentReactionNotificationActionData
     */
    entityId: string;
    /**
     * 
     * @type {string}
     * @memberof CommentReactionNotificationActionData
     */
    entityUserId: string;
    /**
     * 
     * @type {string}
     * @memberof CommentReactionNotificationActionData
     */
    reacterUserId: string;
    /**
     * 
     * @type {string}
     * @memberof CommentReactionNotificationActionData
     */
    commentId?: string;
}


/**
 * @export
 */
export const CommentReactionNotificationActionDataTypeEnum = {
    Track: 'Track',
    Playlist: 'Playlist',
    Album: 'Album'
} as const;
export type CommentReactionNotificationActionDataTypeEnum = typeof CommentReactionNotificationActionDataTypeEnum[keyof typeof CommentReactionNotificationActionDataTypeEnum];


/**
 * Check if a given object implements the CommentReactionNotificationActionData interface.
 */
export function instanceOfCommentReactionNotificationActionData(value: object): value is CommentReactionNotificationActionData {
    let isInstance = true;
    isInstance = isInstance && "type" in value && value["type"] !== undefined;
    isInstance = isInstance && "entityId" in value && value["entityId"] !== undefined;
    isInstance = isInstance && "entityUserId" in value && value["entityUserId"] !== undefined;
    isInstance = isInstance && "reacterUserId" in value && value["reacterUserId"] !== undefined;

    return isInstance;
}

export function CommentReactionNotificationActionDataFromJSON(json: any): CommentReactionNotificationActionData {
    return CommentReactionNotificationActionDataFromJSONTyped(json, false);
}

export function CommentReactionNotificationActionDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): CommentReactionNotificationActionData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'type': json['type'],
        'entityId': json['entity_id'],
        'entityUserId': json['entity_user_id'],
        'reacterUserId': json['reacter_user_id'],
        'commentId': !exists(json, 'comment_id') ? undefined : json['comment_id'],
    };
}

export function CommentReactionNotificationActionDataToJSON(value?: CommentReactionNotificationActionData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'type': value.type,
        'entity_id': value.entityId,
        'entity_user_id': value.entityUserId,
        'reacter_user_id': value.reacterUserId,
        'comment_id': value.commentId,
    };
}

